import ToggleNewData from './ToggleNewData';
import SetUpdatedAtCols from './SetUpdatedAtCols';
import UpdateTotals from './UpdateTotals';
import UpdateProgressBar from './UpdateProgressBar';
import RemoveMultiOption from './RemoveMultiOption';

const MULTI_SELECTOR = '.manual-list-typeahead-multiple';
const SELECTED_OPTION_CLASS = 'selected-opt w-100 p-2 d-flex align-items-center';
const REMOVE_MULTI_TOOLTIP = 'Remove selected option';
const REMOVE_ICON_SVG = "<svg width='14' height='16' viewBox='0 0 14 16' fill='none' xmlns='http://www.w3.org/2000/svg'><g><path d='M4.2 3.79989V2.39989C4.2 1.88442 4.61787 1.46655 5.13333 1.46655H8.86667C9.38213 1.46655 9.8 1.88442 9.8 2.39989V3.79989M0.875 4.26655H13.125M2.275 4.26655V13.5999C2.275 14.1154 2.69287 14.5332 3.20833 14.5332H10.7917C11.3071 14.5332 11.725 14.1154 11.725 13.5999V4.26655M7 7.12489V11.8499M5.075 7.12489V11.8499M8.925 7.12489V11.8499' stroke='#DA3547' stroke-linecap='round' stroke-linejoin='round'></path></g></svg>";

function isMultiSelect(answerField) {
  return answerField.attr('type') === 'hidden' && answerField.closest('.form-group').find(MULTI_SELECTOR).length > 0;
}

function buildSelectedOption(text) {
  const wrapper = $('<div>').addClass(SELECTED_OPTION_CLASS).attr('data-text', text);
  $('<div>').addClass('mr-2').text(text).appendTo(wrapper);

  const actions = $('<div>').addClass('ml-auto').appendTo(wrapper);
  $('<a>')
    .addClass('clickable remove-multi-select')
    .attr('data-text', text)
    .attr('data-toggle', 'tooltip')
    .attr('data-title', REMOVE_MULTI_TOOLTIP)
    .html(REMOVE_ICON_SVG)
    .appendTo(actions);

  return wrapper;
}

function applyMultiSelectValue(answerField, value) {
  const formGroup = answerField.closest('.form-group');
  const container = formGroup.find('.multi-selected-container');
  const manualInput = formGroup.find(MULTI_SELECTOR);
  container.empty();

  const selectionText = (value || '').trim();
  if (selectionText.length === 0) {
    answerField.val('').trigger('change');
    manualInput.val('');
    return;
  }

  const selections = selectionText.split('|').map((item) => item.trim()).filter((item) => item.length > 0);
  answerField.val(selections.join('|'));
  manualInput.val('');

  selections.forEach((selection) => {
    container.append(buildSelectedOption(selection));
  });

  RemoveMultiOption();
}

function applyValue(questionRow, answerField, value) {
  if (isMultiSelect(answerField)) {
    applyMultiSelectValue(answerField, value);
  } else {
    answerField.val(value);
    answerField.focus().blur();
    if (answerField.hasClass('manual-list-typeahead') && typeof answerField.typeahead === 'function') {
      answerField.typeahead('val', value);
      const typeaheadInput = answerField.closest('.twitter-typeahead').find('.tt-input');
      if (typeaheadInput.length > 0) {
        typeaheadInput.val(value);
      }
      answerField.trigger('typeahead:select', [value]);
    }
  }

  answerField.trigger('input').trigger('change');
  ToggleNewData(answerField);
  SetUpdatedAtCols(answerField);
  UpdateTotals(answerField);
  UpdateProgressBar(answerField[0]);
  questionRow.removeClass('incomplete');
}

export default function(parentContainer) {
  parentContainer.off('click.applyHistoricalAnswer', '.apply-historical-answer');
  parentContainer.on('click.applyHistoricalAnswer', '.apply-historical-answer', function(event) {
    event.preventDefault();

    const trigger = $(this);
    const questionRow = trigger.closest('.question-row');
    if (questionRow.length === 0) {
      return;
    }

    const answerField = questionRow.find('.answer-text').first();
    if (answerField.length === 0) {
      return;
    }

    let historicalText = trigger.data('historical-text');
    if (typeof historicalText === 'undefined' || historicalText === null) {
      historicalText = '';
    } else {
      historicalText = String(historicalText);
    }
    applyValue(questionRow, answerField, historicalText);

    const tooltipInstance = trigger.data('bs.tooltip');
    if (tooltipInstance && typeof tooltipInstance.hide === 'function') {
      tooltipInstance.hide();
    }
  });
}
